<template>
  <div style="width: 100%; height: 100%" class="box-container ma-0 pa-0">
    <v-dialog v-model="dialog.modal_column_selector" v-if="dialog.modal_column_selector" :min-width="200" :max-width="300" :min-height="200" persistent width="auto" height="auto">
      <grid-column-selector></grid-column-selector>
    </v-dialog>
    <v-dialog right v-model="exportWindow" max-width="300px" value="exportWindow" style="overflow: hidden">
      <v-container class="ma-0 pa-0" style="overflow: hidden">
        <v-card class="ma-0 pa-0" align-items="center">
          <v-card-title class="ma-0 pa-0 mb-3">
            <v-row class="ma-0 pa-0" justify="center" align="center">
              <v-btn color="none" text fab small class="no-background-hover" :ripple="false" style="cursor: default">
                <v-divider></v-divider>
              </v-btn>
              <v-divider></v-divider>
              <span class="ma-2 subtitle-1">{{ TR.Format }}</span>
              <v-divider></v-divider>
              <v-btn color="error" text fab small @click="exportWindow = !exportWindow">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-row>
          </v-card-title>
          <v-select class="pa-3" dense :items="exportFormats" item-value="csv" v-model="selectedFormat" :label="TR.Format"></v-select>
          <v-row justify="center" class="ma-0 pa-2 pb-2">
            <v-btn block :color="isInDarkMode ? '' : 'grey lighten-3'" tile class="elevation-0" @click="exportTable">
              <span>{{ TR.Download }}</span>
              <v-icon right color="success">mdi-arrow-down-bold</v-icon>
            </v-btn>
          </v-row>
        </v-card>
      </v-container>
    </v-dialog>
    <div class="row-header ma-0 pa-0">
      <v-row align="center" class="ma-2 pa-0" justify="center">
        <slot name="header_top"></slot>
        <v-row :justify="isOnMobile ? 'center' : 'start'" align="center" class="ma-0 pa-0">
          <template v-if="datatype && datatype.require_choice">
            <t-date-range-input v-model="datatype.datesFromTo" @click="$router.loadRouteData(route, true)" style="width: 260px; max-width: 260px" class="ma-1 pa-0 subtitle-2 centered-input" :label="TR.Period" :clearable="false"></t-date-range-input>
          </template>
          <template v-if="predefinedfilters">
            <template v-for="(ff, fix) in predefinedfilters">
              <v-tooltip :disabled="ff.vals.length == 0" :key="'_t' + fix" bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-select
                      class="ma-2 pa-0 subtitle-2"
                      v-if="ff.cantBeNull"
                      v-model="ff.vals[0]"
                      return-object
                      @change="appendFilter(ff)"
                      :items="getFiltersUniqueValues(ff)"
                      :label="ff.text"
                      hide-details
                      dense
                      :no-data-text="TR.NoData"
                      :item-color="isInDarkMode ? '#FFFFFF' : ''"
                      style="width: 100px; max-width: 100px"
                    >
                    </v-select>
                    <v-select
                      v-else-if="ff.type == DataFilterType.In"
                      class="ma-2 pa-0 subtitle-2"
                      v-model="ff.vals"
                      return-object
                      multiple
                      @change="appendFilter(ff)"
                      :items="getFiltersUniqueValues(ff)"
                      clearable
                      :label="ff.text"
                      hide-details
                      dense
                      :no-data-text="TR.NoData"
                      :item-color="isInDarkMode ? '#FFFFFF' : ''"
                      style="width: 200px; max-width: 200px"
                    >
                      <template v-slot:selection="{ index }">
                        <span v-if="index === 0">{{ ff.vals.join(", ").padRight(15, " ").substring(0, 14) + "…" }}</span>
                      </template>
                    </v-select>
                    <v-select
                      class="ma-2 pa-0 subtitle-2"
                      v-else-if="ff.type == DataFilterType.WeekDays"
                      v-model="ff.vals"
                      return-object
                      multiple
                      @change="appendFilter(ff)"
                      :items="getFiltersUniqueValues(ff)"
                      clearable
                      :label="ff.text"
                      hide-details
                      dense
                      :no-data-text="TR.NoData"
                      :item-color="isInDarkMode ? '#FFFFFF' : ''"
                      style="width: 200px; max-width: 200px"
                    >
                      <template v-slot:selection="{ index }">
                        <span v-if="index === 0">{{ ff.vals.join(", ").padRight(15, " ").substring(0, 14) + "…" }}</span>
                      </template>
                    </v-select>
                  </div>
                </template>
                <v-row class="ma-0 pa-0" v-for="(line, idx) in ff.vals" :key="idx" :color="isInDarkMode ? 'rgba(0,0,0,1)' : ''">{{ line }}</v-row>
              </v-tooltip>
              <!-- <v-select class="ma-2 pa-0 subtitle-2" v-if="ff.type == DataFilterType.In" :key="'_' + fix" v-model="ff.vals[0]" @change="appendFilter(ff)" :items="getFiltersUniqueValues(ff)" clearable :label="ff.text" hide-details dense :item-color="isInDarkMode ? '#FFFFFF' : ''" style="width: 200px; max-width: 200px">
                <template slot="item" slot-scope="data">
                  <span :style="isOnMobile ? 'font-size: 12px;' : ''" class="pl-2 subtitle-2">{{ data.item }}</span>
                </template>
              </v-select> -->
              <t-date-range-input
                v-if="ff.proptype == DataPropType.Date && ff.type == DataFilterType.Between && ff.propname != 'date'"
                :ref="'refPredefinedFilter' + ff.propname"
                style="width: 200px; max-width: 200px"
                class="ma-1 pa-0 subtitle-2"
                :key="'_' + fix"
                v-model="ff.vals"
                :label="ff.text"
                @input="appendFilter(ff)"
              ></t-date-range-input>
            </template>
          </template>
          <v-row :justify="isOnMobile ? 'center' : 'start'" align="center" class="ma-0 pa-0">
            <!-- <t-filter-button :datatype="datatype" :btnDisabled="isLoading" :class="'ma-1'" /> -->
            <t-filter-button
              :datatype="datatype"
              :btnDisabled="isLoading"
              :class="'ma-1'"
              @click.native.prevent="
                isFilterMenuVisible = !isFilterMenuVisible;
                recalcGridHeight();
              "
            />
            <v-spacer v-if="!isOnMobile"></v-spacer>
            <t-button :class="'ma-1'" :btnDisabled="isLoading" :btnText="isOnMobile ? '' : TR.Columns" :btnIcon="'mdi-format-columns'" @click.native="selectColumns()" />
            <t-button :class="'ma-1' + (isOnMobile ? '' : ' mr-10')" :btnDisabled="isLoading" :btnText="isOnMobile ? '' : TR.Export" :btnIcon="'mdi-file-export'" @click.native="showExportWindow()" />
          </v-row>
        </v-row>
        <v-col cols="12" class="ma-0 pa-0">
          <v-row v-if="isFilterMenuVisible" class="ma-0 pa-0">
            <t-filters v-if="isFilterMenuVisible" :datatype="datatype" />
          </v-row>
        </v-col>
        <slot name="header_bottom"></slot>
      </v-row>
    </div>
    <div class="row-content elevation-3" ref="refGridContainer" id="virtual-scroll-container" :class="isOnMobile ? '' : 'mx-3 mb-2'">
      <v-data-table
        :dense="isOnMobile || userSettings.denseGrid"
        id="virtual-scroll-table"
        class="ma-0 pa-0 elevation-0 customscroll"
        ref="refGrid"
        disable-sort
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :headers="getHeaders"
        :items="getData"
        item-key="my_custom_id"
        locale="bg-BG"
        :mobile-breakpoint="0"
        fixed-header
        :height="gridHeight"
        multi-sort
        hide-default-footer
        :loading="isLoading"
        :loading-text="TR.DataProcessingPleaseWait"
        disable-pagination
      >
        <template v-slot:no-data>
          <v-row align="center" justify="center">
            <v-alert :value="true" color="default" icon="mdi-emoticon-sad">{{ TR.NoDataForShowing }}</v-alert>
          </v-row>
        </template>

        <!-- <template slot="header">
          <th v-for="(h, index) in getHeaders" :key="index" :class="h.divider ? 'v-data-table__divider' : ''">
            {{ header.text }}
            <v-text-field>asd</v-text-field> TODO FILTERS in grid
          </th>
        </template>-->

        <template v-for="(h, index) in dataheaders" v-slot:[`header.${h.value}`]="{ header }">
          <div v-if="h.value == 'my_custom_number'" :key="index" :style="'max-height: ' + (headersHeight + footerHeight) + 'px; height: ' + (headersHeight + footerHeight) + 'px;'">
            {{ header.text }}
          </div>
          <div v-else @click="headerClick(header)" :key="'dhhh' + index" :style="'cursor: pointer; max-height: ' + (headersHeight + footerHeight) + 'px; height: ' + (headersHeight + footerHeight) + 'px;'">
            <div :style="'height: ' + headersHeight + 'px;'">
              <div :style="'display: flex; justify-content: center; align-items: center; height: ' + headersHeight / 2 + 'px;'">
                <span style="white-space: nowrap">{{ header.text }}</span>
              </div>
              <div :style="'display: flex; justify-content: center; align-items: center; height: ' + headersHeight / 2 + 'px;'">
                <v-icon v-if="headerIsSorted(header)" small>{{ getHeaderSortIcon(header) }}</v-icon>
                <v-chip v-if="headerIsSorted(header)" x-small style="cursor: pointer">{{ headerNumber(header) }}</v-chip>
              </div>
            </div>

            <!-- <v-text-field :key="index">asd</v-text-field> TODO FILTERS in grid -->
            <div v-if="hasFooter" :key="'th' + index" :style="'height: ' + footerHeight + 'px;'">
              <span class="data-grid-cell" style="font-weight: bold" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">{{
                h.summable ? TR.Total + ": " + formatCell(h.proptype, getTotalSum(h.value)) : ""
              }}</span>
            </div>
          </div>
        </template>

        <template v-for="(h, index) in dataheaders" v-slot:[`item.${h.value}`]="{ item }">
          <span v-if="h.value == 'my_custom_number'" :key="index" class="data-grid-cell" style="justify-content: center">
            {{ item.my_custom_id + startRow - extraBottom + 1 }}
          </span>
          <span
            v-else
            :key="'hhhhh' + index"
            class="data-grid-cell"
            :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';' + (hasCellClickEvent(h.value) ? ' cursor: pointer; text-decoration: underline;' : '')"
            @contextmenu.stop="showContextMenu($event, item)"
            @click="getCellClickEvent($event, item, h.value)"
          >
            {{ formatCell(h.proptype, Object.byString(item, h.value)) }}
          </span>
        </template>

        <!-- <template v-slot:body v-if="dataitems && dataitems.length > 0">
          <template v-for="(item, iix) in getData">
            <tr :key="iix">
              <td v-for="(h, index) in getHeaders" :key="index" :style="'height: ' + rowHeight + 'px'">
                <span class="data-grid-cell" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';' + (hasCellClickEvent(h.value) ? ' cursor: pointer; text-decoration: underline;' : '') " @contextmenu.stop="showContextMenu($event, item)" @click="getCellClickEvent($event, item, h.value)">
                  {{ formatCell(h.proptype, Object.byString(item, h.value)) }}
                </span>
              </td>
            </tr>
          </template>
        </template>-->

        <!-- <template v-slot:footer :style="'height: ' + rowHeight + 'px'">
         <tr v-if="hasFooter">
            <td v-for="(hf, hfidx) in getHeaders" :key="'th' + hfidx" :style="isInDarkMode ? 'border-right: 1px solid #444444; border-bottom: 1px solid #444444;' : 'border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd;'">
              <span class="data-grid-cell" style="font-weight: bold" :style="hf.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + hf.cell_align + ';'">
                {{ hf.summable ? formatCell(hf.proptype, getTotalSum(hf.value)) : "" }}
              </span>
            </td>
          </tr>
        </template>-->

        <template slot="body.prepend" v-if="dataitems && dataitems.length > 0 && startRow > extraBottom">
          <tr v-if="startRow > 0">
            <td :colspan="getHeaders.length" :style="'padding-top: ' + getStartHeight + 'px'"></td>
          </tr>
        </template>

        <template slot="body.append" v-if="dataitems && dataitems.length > startRow + visibleRows + extraTop">
          <tr>
            <td :colspan="getHeaders.length" :style="'padding-top: ' + getEndHeight + 'px'"></td>
          </tr>
        </template>

        <!-- <template v-if="dataitems && dataitems.length > 0 && dataheaders && getHeaders.some((ff) => ff.summable)" slot="body.append">
          <tr>
            <td v-for="(hf, hfidx) in getHeaders" :key="'th' + hfidx" :style="isInDarkMode ? 'border-right: 1px solid #444444; border-bottom: 1px solid #444444;' : 'border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd;'">
              <span class="data-grid-cell" style="font-weight: bold" :style="hf.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + hf.cell_align + ';'">{{ hf.summable ? formatCell(hf.proptype, getTotalSum(hf.value)) : "" }} </span>
            </td>
          </tr>
        </template>-->
      </v-data-table>
    </div>
    <v-menu v-model="showMenu" :position-x="mouseX" :position-y="mouseY" absolute offset-y outline>
      <v-list v-if="clickedDevice" dense outlined>
        <v-list-item v-if="!isUserObserver() && clickedDevice.duprofile && clickedDevice.duprofile.cosmosableDevice" @click="editDevice(clickedDevice)">
          <v-icon :color="Colors.IconColor" size="28">mdi-pencil</v-icon>
          <v-list-item-title class="pl-2">
            {{ TR.Grid_EditInfoFor + " " + clickedDevice.sn }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="clickedDevice.duprofile" @click="showModalMap()">
          <v-icon :color="Colors.IconColor" size="28">mdi-google-maps</v-icon>
          <v-list-item-title class="pl-2">{{ TR.Grid_ShowOnTheMap + " " + getClickedDeviceName }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="!isUserObserver() && clickedDevice.duprofile && clickedDevice.duprofile.cosmosableDevice && ((clickedDevice.duprofile.csubscriptionPlan && clickedDevice.duprofile.csubscriptionPlan.id == -1) || !clickedDevice.duprofile.csubscriptionPlan)"
          @click="goSubscribe()"
        >
          <v-icon :color="Colors.IconColor" size="28">mdi-cash</v-icon>
          <v-list-item-title class="pl-2">{{ TR.Grid_Subscribe + " " + getClickedDeviceName }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isUserObserver() && clickedDevice.duprofile && clickedDevice.duprofile.csubscriptionPlan && clickedDevice.duprofile.csubscriptionPlan.id > 0" @click="changeSubscription()">
          <v-icon :color="Colors.IconColor" size="28">mdi-cash-multiple</v-icon>
          <v-list-item-title class="pl-2">
            {{ TR.Grid_ChangePlan + " " + getClickedDeviceName }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isUserObserver() && clickedDevice.duprofile && clickedDevice.duprofile.csubscriptionPlan && clickedDevice.duprofile.csubscriptionPlan.id > 0" @click="stopSubscription()">
          <v-icon :color="Colors.IconColor" size="28">mdi-close-circle-outline</v-icon>
          <v-list-item-title class="pl-2">
            {{ TR.Grid_DeactivatePlan + " " + getClickedDeviceName }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="openTremolSite(clickedDevice.model.name)">
          <v-img :src="clickedDevice.Image" contain width="28" height="28"></v-img>
          <v-list-item-title class="pl-2">
            {{ TR.Grid_InstructionOnWebsite + " " + clickedDevice.model.name }}
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="copyCell()">
          <v-icon :color="Colors.IconColor" size="28">mdi-content-copy</v-icon>
          <v-list-item-title class="pl-2">{{ TR.CopyCell }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import bus, { g_Dialog, TR } from "../main";
import DataManager, { DataFilterType, DataPropType, ErrorMessage } from "../js/DataManager";
import GridColumnSelector from "./Controls/DataGridColumnSelector";
import XLSX from "xlsx";
import RobotoFont from "../assets/fonts/Roboto";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  components: {
    GridColumnSelector,
  },
  data() {
    return {
      TR: TR,
      datatype: null,
      route: null,
      expanded: [],
      dataitems: [],
      dataheaders: [],
      dataheadersexpanded: [],
      message: null,
      title: "",

      clickedDevice: null,
      clickedText: null,
      mouseX: 0,
      mouseY: 0,
      onfocus: false,
      isFilterMenuVisible: false,
      sortChanged: false,
      virtualScrollerOffset: 0,
      dataTable: null,
      startRow: 0,
      extraRecords: 100,
      scrollTimeout: 80,
      extraBottom: 0,
      extraTop: 0,
      headersHeight: 42,
      scrollTimeoutFn: null,
      visibleRows: 25,
      sortBy: [],
      sortDesc: [],
      gridHeight: "100%",
      predefinedfilters: [],
      clickEventArray: ["Address", "ReceiptType", "Device", "Name"],
      showMenu: false,
      exportWindow: false,
      wantsToExport: false,
      selectedFormat: "pdf",
      exportFormats: ["pdf", "csv", "xls"],
    };
  },
  computed: {
    isLoading() {
      return this.datatype == null || this.dataitems == null || this.datatype.isLoading;
    },
    DataFilterType() {
      return DataFilterType;
    },
    DataPropType() {
      return DataPropType;
    },
    hasFooter() {
      return this.getHeaders.some((h) => h.summable);
    },
    footerHeight() {
      return this.hasFooter ? this.rowHeight : 0;
    },
    getHeaders() {
      return this.dataheaders.filter((h) => !h.hidden).map((item, index) => ({ my_custom_id: index, ...item }));
    },
    getClickedDeviceName() {
      return this.clickedDevice.sn + (this.clickedDevice.Name ? " (" + this.clickedDevice.Name + ")" : "");
    },
    rowHeight() {
      return this.isOnMobile || this.userSettings.denseGrid ? 32 : 48;
    },
    getStartHeight() {
      return (this.startRow - this.extraBottom) * this.rowHeight;
    },
    getEndHeight() {
      return (this.dataitems.length - this.startRow - this.visibleRows - this.extraTop) * this.rowHeight;
    },
    getData() {
      // console.log(this.dataitems);
      if (this.message) {
        //router.push({ path: "/login", params: { errors: this.message } });
        this.dialogLoader.showError(this.message, { location: "center" });
        //alert(this.message);
        return [];
      }

      // this.sortBy.forEach((s, idx) => {
      //   var h = this.dataheaders.find((h) => h.value == s);
      //   data.sort(h.sort);
      //   if (this.sortDesc[idx]) {
      //     data.reverse();
      //   }
      // });
      return this.dataitems.slice(this.startRow - this.extraBottom, this.startRow + this.visibleRows + this.extraTop).map((item, index) => ({ my_custom_id: index, ...item }));
    },
  },
  methods: {
    onScroll(e) {
      // debounce if scrolling fast
      //console.log("onscroll");
      if (!e) return;
      if (this.scrollTimeoutFn) clearTimeout(this.scrollTimeoutFn);
      this.scrollTimeoutFn = setTimeout(() => {
        const { scrollTop } = e.target;
        const rows = Math.ceil(scrollTop / this.rowHeight);
        var len = this.dataitems.length;
        this.startRow = len - this.visibleRows < rows ? len - this.visibleRows : rows;
        this.extraTop = this.startRow + this.visibleRows + this.extraRecords > len ? len - (this.startRow + this.visibleRows) : this.extraRecords;
        this.extraBottom = this.startRow - this.extraRecords > 0 ? this.extraRecords : this.startRow;

        this.$nextTick(() => {
          e.target.scrollTop = scrollTop;
          this.virtualScrollerOffset = scrollTop;
        });
      }, this.scrollTimeout);
    },
    headerClick(header) {
      setTimeout(() => {
        var hix = this.sortBy.indexOf(header.value);
        if (hix == -1) {
          this.sortBy.push(header.value);
          this.sortDesc.push(false);
        } else {
          if (this.sortDesc[hix] == false) {
            this.sortDesc[hix] = true;
          } else {
            this.sortDesc.splice(hix, 1);
            this.sortBy.splice(hix, 1);
          }
        }
        this.sortChanged = true;
        this.refreshData();
      }, 50);
    },
    headerIsSorted(header) {
      return this.sortBy.indexOf(header.value) != -1;
    },
    getHeaderSortIcon(header) {
      return this.sortDesc[this.sortBy.indexOf(header.value)] ? "mdi-arrow-up" : "mdi-arrow-down";
    },
    headerNumber(header) {
      return this.sortBy.indexOf(header.value) + 1;
    },
    setFocus(on) {
      this.onfocus = on;
      if (on) this.recalcGridHeight();
    },
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.datatype.isLoading = true;
      this.title = meta.title;
      this.route = meta.route;
      this.message = "";
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.predefinedfilters = DataManager.filters_predefined[this.datatype.id];
        this.dataheaders = DataManager.getHeaders(this.datatype);
        this.dataheaders
          .filter((h) => !h.canBeClicked)
          .forEach((f) => {
            var ix = this.clickEventArray.indexOf(f.value);
            if (ix > -1) {
              this.clickEventArray.splice(ix, 1);
            }
          });
        this.dataheadersexpanded = DataManager.getHeadersExpanded(this.datatype);
        this.dataheaders.forEach((f) => {
          if (!f.hidden) this.$set(f, "hidden", false);
        });
        this.predefinedfilters.forEach((f) => {
          if (f.vals && f.vals[0] != null) {
            DataManager.setFilters(this.datatype, [f]);
          }
        });
        this.showWarning();
        this.$refs.refGrid.$el.querySelector(".v-data-table__wrapper").scrollTop = this.virtualScrollerOffset; //ако си цъкнал друг таб и се върнеш
      } else {
        this.message = error.Message;
      }
      // if (this.dataitems.length == 0)
      this.$nextTick(() => {
        this.refreshData();
      });
    },
    getFiltersUniqueValues(filter) {
      if (filter.type == DataFilterType.WeekDays) {
        var days = DataManager.WeekDays.slice(0, DataManager.WeekDays.length);
        var todayIdx = new Date().getDay();
        if (todayIdx > 0) {
          var daysToStay = days.slice(todayIdx, 7);
          var daysToMove = days.slice(0, todayIdx);
          return [...daysToStay, ...daysToMove];
        } else {
          return days;
        }
      } else {
        return DataManager.getFilterDistinctValues(this.datatype, filter).reverse();
      }
    },
    appendFilter(filter) {
      this.showWarning(filter);
      DataManager.appendFilter(this.datatype, filter);
    },
    showWarning(filter) {
      var allData = DataManager.getData(this.datatype, true);
      var devs = DataManager.getSubscribedDevs(true);
      var devsSn = devs.map((d) => d.sn);
      var rr = "";
      if (
        !filter &&
        this.datatype == DataManager.DataType.daily_reports &&
        this.datatype.datesFromTo &&
        this.datatype.datesFromTo[0].getDateWithoutTime().getTime() == this.datatype.datesFromTo[1].addSeconds(-1).getDateWithoutTime().getTime() &&
        this.datatype.datesFromTo[0].getDateWithoutTime().getTime() != new Date().getDateWithoutTime().getTime()
      ) {
        // идва от datatype.datesFromTo
        var dvz = allData.filter((d) => Object.byString(d, "date").between(this.datatype.datesFromTo[0], this.datatype.datesFromTo[1])).map((d) => d.sn);
        var miss = devsSn.filter((d) => dvz.indexOf(d) == -1);
        if (miss.length > 0) {
          rr += this.datatype.datesFromTo[0].toTremolFpStringShort() + ": " + miss.join(", ") + "\n";
        }
      } else if (!!filter && filter.propname == "MonthYY" && filter.vals) {
        for (var i = 0; i < filter.vals.length; i++) {
          var dt = allData.filter((d) => Object.byString(d, "MonthYY") == filter.vals[i]).map((d) => d.sn);
          var missing = devsSn.filter((d) => dt.indexOf(d) == -1);
          if (missing.length > 0) {
            rr += filter.vals[i].toString() + ": " + missing.join(", ") + "\n";
          }
        }
      }
      // var filterCurrency = DataManager.getFilters(this.datatype.id).find((ff) => TR.Currency == ff.propname);
      // if (TR.Locale == Translation.bg.Locale && filterCurrency && this.datatype.datesFromTo && this.datatype.datesFromTo[0].getTime() < g_euroDate.getTime() && this.datatype.datesFromTo[1].getTime() > g_euroDate.getTime()) {

      // }
      if (rr) {
        this.dialogLoader.showInfo(TR.Grid_DevsWithNoData + ":\n" + rr, { timeout: 60000, showCopy: true });
      }
    },
    recalcGridHeight() {
      setTimeout(() => {
        if (this.$refs.refGridContainer && this.$refs.refGridContainer.clientHeight > 0) {
          this.visibleRows = Math.trunc((this.$refs.refGridContainer.clientHeight - this.headersHeight) / this.rowHeight);
          this.gridHeight = this.$refs.refGridContainer.clientHeight - 1;
          //this.gridHeight = this.headersHeight + this.visibleRows * this.rowHeight + "px";

          // if (this.hasFooter) {
          //   this.visibleRows--; //footer
          // }
        }
      }, 500);
    },
    hasCellClickEvent(prop) {
      return this.clickEventArray.indexOf(prop) !== -1;
    },
    getCellClickEvent(event, row, prop) {
      if (this.clickEventArray.indexOf(prop) == -1) {
        return null;
      }
      if (prop == "Address") {
        return this.adressCellClick(row[prop]);
      } else if (prop == "ReceiptType") {
        return this.showModalReceipt(row);
      } else if (prop == "Device" || prop == "Name") {
        return this.showContextMenu(event, row);
      }
      return null;
    },
    getPropText(prop) {
      return [Object.values(prop)[0]];
    },
    getTotalSum(value) {
      var val = this.dataitems.map((f) => f[value]).sum();
      return isNaN(val) ? "" : val;
    },
    showExportWindow() {
      if (this.dataitems.length > 10000) {
        this.dialog.show(
          "yes-no",
          null,
          {
            title: TR.Attention,
            buttonYesText: TR.Yes,
            buttonNoText: TR.No,
            text: TR.Grid_TooManyDataConfirmExport,
          },
          (result) => {
            if (result) {
              this.exportWindow = true;
            }
          }
        );
      } else {
        this.exportWindow = true;
      }
    },
    showContextMenu(event, item) {
      event.preventDefault();
      this.showMenu = false;
      this.clickedDevice = DataManager.getData(DataManager.DataType.devices).find((d) => d.sn == item.sn || d.sn == item.SN);
      this.clickedText = event.target.innerText;
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;
      this.$nextTick(() => {
        if (this.clickedDevice) {
          setTimeout(() => {
            this.showMenu = true;
          }, 100);
        }
      });
    },
    copyCell() {
      this.clickedText.copyToClipboard();
    },
    adressCellClick(cellAddressValue) {
      if (cellAddressValue) {
        this.dialog.show("google-map", null, {
          //this.$modal.show("modal-map", {
          address: cellAddressValue,
        });
      }
    },
    showModalMap() {
      this.dialog.show("google-map", null, {
        //this.$modal.show("modal-map", {
        address: this.clickedDevice.Address,
      });
    },
    showModalReceipt(row) {
      this.dialog.show("receipt-view", row);
      // this.$modal.show("modal-receipt", {
      //   row: row
      // });
    },
    goSubscribe() {
      this.$router.push({ path: "/" + TR.Locale + "/subscription" }).then(
        this.$nextTick(() => {
          bus.$emit(bus.EVENT_Device_want_to_subscribe, this.clickedDevice);
        })
      );
    },
    changeSubscription() {
      this.$router.push({ path: "/" + TR.Locale + "/subscription" }).then(
        this.$nextTick(() => {
          bus.$emit(bus.EVENT_Device_want_to_subscribe, this.clickedDevice);
        })
      );
    },
    stopSubscription() {
      this.$router.push({ path: "/" + TR.Locale + "/subscription" }).then(
        this.$nextTick(() => {
          bus.$emit(bus.EVENT_Device_want_to_unsubscribe, this.clickedDevice);
        })
      );
    },
    // showFilters() {
    //   this.dialog.show(g_Dialog.dialog_types.filter_view, this.datatype);
    // },
    selectColumns() {
      this.dialog.show(g_Dialog.dialog_types.column_selector, this.datatype);
    },
    isUserObserver() {
      return DataManager.userHasAccess(DataManager.UserTypes.Observer);
    },
    editDevice(dev) {
      this.dialog.show(g_Dialog.dialog_types.device_edit, dev);
    },
    getExportTitle() {
      return ("TremolAssistant_" + this.title + "_" + new Date().toTremolFpString()).replaceAll(" ", "_");
    },
    getExportData(includeTotals) {
      let headers = this.dataheaders.filter((h) => !h.hidden && h.value != "my_custom_number");
      let rows = [];
      this.dataitems.forEach(function (e) {
        var r = [];
        headers.forEach((h) => r.push(DataManager.formatGridData(h.proptype, Object.byString(e, h.value))));
        rows.push(r);
      });
      if (includeTotals) {
        var r = [];
        headers.forEach((h) => r.push(h.summable ? this.formatCell(h.proptype, this.getTotalSum(h.value)) : ""));
        rows.push(r);
      }
      return { headers: headers.map((h) => h.text), rows: rows };
    },
    exportTable() {
      this.exportWindow = !this.exportWindow;
      this.dialog.show(g_Dialog.dialog_types.loader, null, { message: TR.ExportingDataPleaseWait });
      setTimeout(() => {
        this.exportTableAsync().then(() => {
          this.dialog.close();
        });
      }, 1000);
    },
    exportTableAsync() {
      return new Promise((resolve) => {
        var expData = this.getExportData(this.selectedFormat == "pdf");
        try {
          if (this.selectedFormat == "xls" || this.selectedFormat == "csv") {
            var sheet = XLSX.utils.json_to_sheet([expData.headers].concat(expData.rows), {
              skipHeader: true,
            });
            // var sheet = XLSX.utils.json_to_sheet(expData.headers, { skipHeader: true });
            // expData.rows.forEach(async row => {
            //   await new Promise(res => {
            //     setTimeout(()=> {
            //       XLSX.utils.sheet_add_json(sheet,row , {
            //         skipHeader: true
            //       });
            //       setTimeout(()=> {
            //         res();
            //       }, 1);
            //     }, 1);
            //   })
            // })

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, sheet);
            XLSX.writeFile(wb, this.getExportTitle() + "." + this.selectedFormat); // name of the file is 'book.xlsx'
          } else if (this.selectedFormat == "pdf") {
            const doc = new jsPDF(expData.headers.length > 6 ? "l" : "p");
            doc.addFileToVFS("Roboto-Regular.ttf", RobotoFont.base64);
            doc.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
            doc.setFont("Roboto-Regular"); // set font
            doc.setFontSize(14);
            doc.text(this.title, 18, 18);
            doc.setFontSize(10);
            doc.autoTable(expData.headers, expData.rows, {
              styles: {
                font: "Roboto-Regular",
                fontStyle: "Roboto-Regular",
              },
              // bodyStyles: {
              //   fillColor: [52, 73, 94],
              // },
              // alternateRowStyles: {
              //   fillColor: [74, 96, 117],
              // },
              headStyles: {
                font: "Roboto-Regular",
                fontStyle: "Roboto-Regular",
              },
              startY: 25,
              showHead: "firstPage",
            });
            // var data = doc.output('arraybuffer')
            // fs.writeFile(this.getExportTitle() + "." + this.selectedFormat, data, resolve);
            doc.save(this.getExportTitle() + "." + this.selectedFormat, { returnPromise: true });
          }
          setTimeout(() => {
            resolve();
          }, 100);
        } catch (ex) {
          this.dialogLoader.showError(TR.ErrorOnExport + "!\n" + ex, { location: "center" });
          setTimeout(() => {
            resolve();
          }, 100);
        }
      });
    },
    formatCell(proptype, value) {
      return DataManager.formatGridData(proptype, value);
    },
    refreshData() {
      this.dataitems = []; // За рефреш на виртуалния скролер ?
      this.$nextTick(() => {
        this.dataitems = DataManager.getData(this.datatype);
        if (this.sortChanged && this.dataitems.length > 0) {
          this.dataitems.sort((a, b) => {
            var i = 0;
            var result = 0;
            while (i < this.sortBy.length && result === 0) {
              var sortFn = this.dataheaders.find((h) => h.value == this.sortBy[i]).sort;
              result = sortFn(Object.byString(a, this.sortBy[i]), Object.byString(b, this.sortBy[i]));
              if (this.sortDesc[i]) result = result * -1;
              i++;
            }
            return result;
          });
          this.sortChanged = false;
        }
        this.datatype.isLoading = false;
        if (this.$refs.refGrid !== undefined && this.dataTable == null) {
          var dt = this.$refs.refGrid.$el.querySelector(".v-data-table__wrapper");
          this.dataTable = dt;
          this.dataTable.addEventListener("scroll", this.onScroll);
        }
        this.recalcGridHeight();
      });
    },
    doFilter(datatype) {
      if (datatype == this.datatype) {
        this.predefinedfilters.forEach((f) => {
          var found = DataManager.getFilters(this.datatype.id).find((ff) => f.propname == ff.propname);
          if (found) {
            f.vals = found.vals;
          } else {
            if (f.proptype == DataPropType.Date) {
              f.vals = [null, null];
            } else {
              f.vals = [];
            }
          }
        });
        this.sortChanged = true;
        this.refreshData();
      }
    },
  },
  watch: {
    "datatype.datesFromTo": {
      handler() {
        this.showWarning();
      },
      deep: true,
    },
    //   sortBy: function (val) {
    //     console.log("sortBy");
    //     console.log(val);
    //   },
    //   sortDesc: function (val) {
    //     console.log("sortDesc");
    //     console.log(val);
    //   },
  },
  mounted() {},
  updated() {},
  destroyed() {
    this.dataTable.removeEventListener("scroll", this.onScroll);
  },
  created() {
    bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
      if (datatype == this.datatype) {
        this.sortChanged = true;
        this.refreshData();
      }
    });
    bus.$on(bus.EVENT_DataManager_FILTERS_CHANGED, (datatype) => {
      this.doFilter(datatype);
    });
    window.addEventListener("resize", this.recalcGridHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcGridHeight);
  },
};
</script>

<style>
.data-grid-cell {
  white-space: nowrap;
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
}

.data-grid-cell-width-divider {
  white-space: nowrap;
  display: flex;
  height: 100%;
  width: calc(100% - 1px);
  align-items: center;
}
</style>